jQuery(function($){
    $(document).ready(function(){
        $("#occupancy_toggle").click(function(e){
            e.preventDefault();
            if ($("#occupancy").hasClass("opened")) {
                $("#occupancy").fadeOut().removeClass("opened");
            } else {
                $("#occupancy").fadeIn().addClass("opened");
            }
        });
    });
});
